import { IRequestSaveWorkingDays } from '@/tools/interfaces/request-save-workingdays.interface';
import { SCHOOL_DAYS_EVENTS, _SCHOOL_CALENDAR_STORE } from '@/tools/values/school-calendar.values';
import Vue from 'vue';
import Component from 'vue-class-component';
import KEYS from '@/values/keys';
import { Prop } from 'vue-property-decorator';
import EdInputModel from '@/models/ed-input.model';
import { WORKING_DAYS } from '@/tools/values/schedule.values';

@Component({
  name: 'ed-config-working-days'
})
export default class EdConfigWorkingDaysComponent extends Vue {

  @Prop() readonly params: any;

  public saving: boolean = false;
  public workingDays: any[] = [];
  public prevWorkingDays: any[] = [];

  get organizationId() {
    let institutions: any[] = this.$store.state.ToolsStore.institutionInfo;
    return institutions.length > 0 ? institutions[0].organizationId : null;
  }

  onChange(inputModel, day) {
    let value:boolean = inputModel.value;
    let i = this.workingDays.findIndex(wd => wd.name == day.name);
    this.workingDays[i].checked = value;
  }

  async saveWorkingDays() {
    try {
      this.saving = true;
      let data: IRequestSaveWorkingDays = {
        organizationId: this.organizationId,
        workingDays: [],
        prevWorkingDays: this.prevWorkingDays
      };
      data.workingDays = this.workingDays
        .filter(item => item.checked)
        .map(item => item.name.toUpperCase());
      this.closeModal();
      setTimeout(async () => {
        await this.params.saveWorkingDaysAction(data);
        this.params.refreshCalendarAction && this.params.refreshCalendarAction();
        this.saving = false;
      }, 200)
    } catch(err) {
      this.saving = false;
      this.$EdModal.createMessageModal({
        title: this.$i18n.t('tools.schooldays.errors.errorSavingDateTitle'),
        body: this.$i18n.t('tools.schooldays.errors.errorSavingDateMsg'),
        type: KEYS.EVENT_TYPES.DANGER
      });
    }
  }

  setWorkingDays() {
    let _enabled : string[] = this.params.enabledWorkingDays?.length > 0 ? 
      this.params.enabledWorkingDays : 
      Object.values(WORKING_DAYS).filter(value => typeof value === 'string');

    this.workingDays = this.params.workingDaysInput.map(wd => {
      return {
        ...wd,
        name: wd.label,
        label: this.$i18n.t(`common.weekdays.${wd.label}`),
        value: wd.checked,
        validators: {},
        valid: false,
        disabled: !_enabled.includes(wd.label.toUpperCase())
      }
    });
  }

  closeModal() {
    this.$EdModal.closeModal();
  }

  created() {
    this.setWorkingDays();
    this.prevWorkingDays = this.workingDays.filter(item => item.checked)
      .map(item => item.name.toUpperCase());
  }

}